import { ChangeDetectionStrategy, Component, HostListener, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';

import { SidebarComponent } from '../../shared/components/sidebar/sidebar.component';
import { MobileTopbarComponent } from '../../shared/components/mobile-topbar/mobile-topbar.component';
import { AppSettingsService } from '../../core/services/app-settings.service';
import { SessionEventsService } from '../../core/services/session-events.service';
import { AuthService } from '../../core/services/auth.service';

@Component({
  selector: 'app-shell',
  standalone: true,
  imports: [CommonModule, RouterOutlet, SidebarComponent, MobileTopbarComponent],
  templateUrl: './shell.component.html',
  styleUrl: './shell.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShellComponent {
  private readonly appSettingsService = inject(AppSettingsService);
  private readonly sessionEventsService = inject(SessionEventsService);
  private readonly authService = inject(AuthService);

  protected readonly isSidebarCollapsed = this.appSettingsService.isSidebarCollapsed;
  protected readonly isMobileSidebarOpen = signal(false);
  protected readonly isPosSession = this.authService.isPosSession();

  constructor() {
    if (!this.isPosSession) {
      this.appSettingsService.loadUserSettings().subscribe();
    }

    this.sessionEventsService.start();
  }

  protected get isMobile(): boolean {
    return window.innerWidth < 960;
  }

  protected toggleSidebar(): void {
    if (this.isMobile) {
      this.isMobileSidebarOpen.update((value) => !value);
      return;
    }

    this.appSettingsService.toggleSidebarCollapsed();
  }

  protected closeMobileSidebar(): void {
    this.isMobileSidebarOpen.set(false);
  }

  @HostListener('window:resize')
  protected onResize(): void {
    if (!this.isMobile) {
      this.isMobileSidebarOpen.set(false);
    }
  }
}